import React from 'react'
import styled from 'styled-components'
import ImgSlider from './Slider'
import Viewers from './SocialMedia'
import Section1 from './Section1'
import WhatsappIcon from './WhatsappIcon'
import LawLessons from './LawLessons'
import Mothafar from './Mothafar'


function Home() {
    return (
        <Container>
           <WhatsappIcon />
           <ImgSlider />
           <Viewers />
           <Mothafar />
           <Section1 />
           <LawLessons />
        </Container>
    )
}

export default Home

const Container = styled.main`
min-height: calc(100vh - 70px);
padding: 36px;
position: relative;
overflow-x: hidden;
    &:before {
        background: url("/images/home-background.png") center center / cover
        no-repeat fixed;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
    }

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        padding: 10px;
        
     
      }

      @media only screen and (max-width: 479px) {
        padding: 10px;
      }
`

